
import type { BlockProps } from "./blocks/registry";
import AboutSectionHome from "../design-system/organisms/AboutSectionHome";

type StrapiMedia = {
  url?: string;
  alternativeText?: string;
};

type AboutFeature = {
  id?: number | string;
  title?: string;
  titre?: string;
  icon?: StrapiMedia;
};

type AboutBlockData = {
  id?: number | string;
  documentId?: string;
  primary_title?: string;
  secondary_title?: string;
  descr?: string;
  image?: StrapiMedia;
  features?: AboutFeature[];
  [key: string]: unknown;
};

type MappedFeature = {
  id: string | number;
  iconSrc: string;
  title: string;
};

type MappedAboutData = {
  primaryTitle: string;
  secondaryTitle: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  features: MappedFeature[];
};

export function mapAboutData(strapiData: AboutBlockData): MappedAboutData | null {
  if (!strapiData) return null;

  const FALLBACK_FEATURES: MappedFeature[] = [
    {
      id: "1",
      iconSrc: "https://site-lms.fra1.digitaloceanspaces.com/menus_2aa862b19a.svg",
      title: "Menus élaborés par une diététicienne",
    },
    {
      id: "2",
      iconSrc: "https://site-lms.fra1.digitaloceanspaces.com/livraison_a4ca75a909.svg",
      title: "Livraison rapide chez vous",
    },
    {
      id: "3",
      iconSrc: "https://site-lms.fra1.digitaloceanspaces.com/commande_baca9fac6a.svg",
      title: "Commande simple en ligne",
    },
    {
      id: "4",
      iconSrc: "https://site-lms.fra1.digitaloceanspaces.com/aides_60dc8a867b.svg",
      title: "Aides fiscales possibles",
    },
  ];

 const features: MappedFeature[] =
  strapiData.features && strapiData.features.length > 0
    ? strapiData.features.map((feature, index) => ({
        id: feature.id ?? `feature-${index}`,
        iconSrc: feature.icon?.url || "/fallback-icon.svg",
        title: feature.title ?? feature.titre ?? "",
      }))
    : FALLBACK_FEATURES;
    
  return {
  primaryTitle: strapiData.primary_title || "",
  secondaryTitle: strapiData.secondary_title || "",
  description: strapiData.descr || "",
  imageSrc: strapiData.image?.url || "/fallback-image.jpg",
  imageAlt: strapiData.image?.alternativeText || "About Image",
  features,
};
}

export default function About({ data }: BlockProps<AboutBlockData>) {
  if (!data) return null;

  const aboutData = mapAboutData(data);

  if (!aboutData) return null;

  return <AboutSectionHome data={aboutData} key={data.documentId} />;
}